import CustomCodeViewer from '../../../core/codeViewer'
import Text from '../../../../utils/text'

const Language = ({language, url, data, urlType, isOs}) => {
    return data?.[language]?.map((item, index) => (
        <div className="step-container" key={index}>
            <div className="title code-title" dangerouslySetInnerHTML={{__html: item.title}}/>
            {item?.text && <div className="code-text" dangerouslySetInnerHTML={{__html: item.text}}/>}
            {item?.code && <CustomCodeViewer
                code={url && urlType ? Text.replaceAllChars(item.code, urlType, url) : item.code}
                language={isOs ? 'bash' : language === 'node' ? 'javascript' : language}/>}
        </div>
    ))
}

export default Language
